import {
	AppActionTypes,
	AppState,
	CLEAR_INLINE_ERRORS,
	HIDE_LOADER,
	SET_INLINE_ERRORS,
	SET_PAGE_ERROR,
	SHOW_LOADER
} from "./types";

const initialState: AppState = {
	isLoading: false,
	loadingText: undefined,
	pageError: undefined,
	inlineErrors: undefined,
};

export const appStateReducer = (state = initialState, action: AppActionTypes): AppState => {
	switch (action.type) {
		case SHOW_LOADER:
			return Object.assign({}, state, { isLoading: true, loadingText: action.payload });
		case HIDE_LOADER:
			return Object.assign({}, state, { isLoading: false, loadingText: undefined });
		case SET_PAGE_ERROR:
			return Object.assign({}, state, { pageError: action.payload });
		case SET_INLINE_ERRORS:
			return Object.assign({}, state, { inlineErrors: Object.assign({}, state.inlineErrors, action.payload) });
		case CLEAR_INLINE_ERRORS:
			if (action.payload) {
				const newPayload = state.inlineErrors;
				if (newPayload) {
					action.payload.forEach((key) => {
						delete newPayload[key];
					});
				}
				return Object.assign({}, state, { inlineErrors: newPayload });
			} else {
				return Object.assign({}, state, {
					inlineErrors: undefined,
				});
			}
		default:
			return state;
	}
};
